import React from 'react';
import styles from './Surface.less';

export const Surface: React.FunctionComponent = ({ children }) => {
  return (
    <div id="surface" className={styles.surface}>
      {children}
    </div>
  );
};
